import { useMemo } from "react";
import { FileInterface } from "../../../types/RecordInterfaces";
import TenantAPI from "../../api/TenantAPI";
import { useQueries, useQuery } from "@tanstack/react-query";

interface Props {
  files: FileInterface[];
}

const useGalleryImage = ({ files }: Props) => {
  const filesPromises = files?.map((file) => {
    return {
      queryKey: ["gallery", file.id],
      queryFn: () => TenantAPI.getFileURL(file.File),
    };
  });

  const aux = useQueries({ queries: filesPromises });
  const loading = aux?.map((f) => f.isLoading);

  // @ts-ignore
  const fetchedURL = useMemo(() => {
    if (!aux) return;
    return aux.map((response, i: number): FileInterface => {
      return {
        ...files[i],
        URL: response.data?.data.data.url,
      };
    });
  }, [filesPromises]);

  return {
    loading: loading?.includes(true) ? true : false,
    fetchedFiles: files?.length > 0 ? null : fetchedURL,
  };
};

export const useGalleryImage2 = (file: FileInterface) => {
  const fileWithImage = useQuery({
    queryKey: ["gallery", file.id],
    queryFn: () => {
      if (file?.PublicURL) return Promise.resolve(file?.PublicURL);
      return TenantAPI.getFileURL(file.File).then(
        (data) => data?.data?.data?.url
      );
    },
    staleTime: Infinity,
  });

  const newFile = {
    ...file,
    URL: fileWithImage.data,
  };

  return {
    fetchedFile: newFile,
    loading: fileWithImage.isLoading,
  };
};

export default useGalleryImage;
